<template>
    <v-app>
        <div class="divPorfesor">
            <div class="divResumenInfo">
                <v-avatar class="hidden-sm-and-down" width="200" height="200">
                    <img :src="img" alt="Lopez">
                </v-avatar>
                <v-img class="hidden-md-and-up" :src="img" alt="Lopez"></v-img>
                <br>
                <br>
                <span class="title">
                    <strong>Dr. Apolinar González Mancilla</strong>
                </span>
                <hr>
                <br>
                <div class="text-left">
                    <div>
                        <p>
                            <v-icon color="red">mdi-email-open</v-icon>
                            <ul>
                                <li>apolinar.gonzalez@ujed.mx</li>
                                <li>poloapolo.3@hotmail.com</li>
                                <li>gonzalez.apolinar@colpos.mx</li>
                            </ul>
                        </p>
                    </div>
                    <v-divider></v-divider>
                    <div class="divSNI">
                        <v-icon color="green">mdi-checkbox-marked-circle</v-icon>
                        <b>SNI</b>
                        <v-spacer></v-spacer>
                        <b>NIVEL: </b> candidato
                    </div>
                    <v-divider></v-divider>
                    <div>
                        <p>
                            <v-icon color="green">mdi-checkbox-marked-circle</v-icon>
                            <b>PROMEP</b>
                        </p>
                    </div>
                    <v-divider></v-divider>
                    <div>
                        <b>CUERPO ACADEMICO</b>
                        <br>
                        <br>
                        <p>OPTIMIZACIÓN DE LOS RECURSOS AGUA-SUELO.</p>
                    </div>
                </div>
                <br>
                <div>
                    <v-btn color="blue" text @click="insertarRuta('/conocenos/planta-academica/')">Regresar</v-btn>
                </div>
            </div>
            <div class="divEstudiosInfo" v-show="info">
                <div id="divAgrupaInfo">
                    <div id="estiloTitulos">
                        <span class="title">
                            <strong>FORMACIÓN ACADEMICA</strong>
                        </span>
                    </div>
                    <div id="licenciatura">
                        <p>
                            <b>LICENCIATURA.</b>
                            <br>
                            INGENIERO AGRÓNOMO (2008)
                            <br>
                            <v-divider class="m-0"></v-divider>
                            UNIVERSIDAD POPULAR DE LA CHONTALPA
                            <br>
                            LUGAR: CÁRDENAS TABASCO, MÉXICO
                        </p>
                        <br>
                        <p>
                            <b>MAESTRIA.</b>
                            <br>
                        <ul>
                            <li>MAESTRÍA EN CIENCIAS EN PRODUCCIÓN AGROALIMENTARIA EN EL TRÓPICO (2010)</li>
                            <p>
                                COLEGIO DE POSTGRADUADOS CAMPUS TABASCO
                            </p>
                        </ul>
                        </p>
                        <br>
                        <p>
                            <b>DOCTORADO.</b>
                            <br>
                        <ul>
                            <li>DOCTORADO EN CIENCIAS EN EDAFOLOGÍA (2016)</li>
                            <p>
                                COLEGIO DE POSTGRADUADOS CAMPUS MONTECILLO
                            </p>
                        </ul>
                        </p>
                    </div>
                </div>
                <div id="divAgrupaInfo" class="mt-2">
                    <div id="estiloTitulos">
                        <span class="title">
                            <strong>ÁREA DE CONOCIMIENTO.</strong>
                        </span>
                    </div>
                    <div id="vinetaCon">
                        <ul>
                            <li>MICROBIOLOGÍA</li>
                            <li>MICROBIOLOGPIA AGRÍCOLA</li>
                            <li>MICROBIOLOGPIA DE SUELOS</li>
                        </ul>
                    </div>
                </div>
                <div id="divAgrupaInfo" class="mt-2">
                    <div id="estiloTitulos">
                        <span class="title">
                            <strong>MÁS INFORMACIÓN.</strong>
                        </span>
                    </div>
                    <div id="vinetaCon" class="pb-1">
                        <v-btn color="blue" @click="info = false; mostrarPublicaciones = true" text>Publicaciones</v-btn>
                        <br>
                        <v-btn color="blue" @click="info = false; mostrarProyectos = true" text>Proyectos</v-btn>
                    </div>
                </div>
            </div>
            <div class="divEstudiosInfo" v-if="info == false && mostrarPublicaciones == true">
                <div id="divAgrupaInfo">
                    <div class="estiloBordes">
                        <span class="title">
                            <strong>PUBLICACIONES.</strong>
                        </span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="info = true; mostrarPublicaciones = false"><v-icon
                                color="red">mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <div class="bordeTabla">
                    <v-data-table :items-per-page="5" dense :headers="headers" :items="Tabla" item-key="numero"
                        class="elevation-1">
                    </v-data-table>
                </div>
            </div>
            <div class="divEstudiosInfo" v-if="info == false && mostrarProyectos == true">
                <div id="divAgrupaInfo">
                    <div class="estiloBordes">
                        <span class="title">
                            <strong>PROYECTOS.</strong>
                        </span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="info = true; mostrarProyectos = false"><v-icon
                                color="red">mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <div class="bordeTabla">
                    <v-data-table :items-per-page="5" dense :headers="headersProy" :items="tablaProyectos" item-key="nombre"
                        class="elevation-1">
                    </v-data-table>
                </div>
            </div>
        </div>
    </v-app>
</template>
<script>
//import datos from `./${personaje._id}`
//const datos = await import(`./${this.datosTabla}.json`);

export default {
    data() {
        return {
            img: require('@/assets/images/Planta Academica/a-gonzalez-m.jpg'),
            item: [],
            datos: null,
            publicaciones: false,
            info: true,
            mostrarPublicaciones: false,
            mostrarProyectos: false,
            headers: [
                {
                    text: 'No.',
                    align: 'start',
                    sortable: false,
                    value: 'numero',
                },
                { text: 'TÍTULO', value: 'titulo' },
                { text: 'AÑO PUBLICACIÓN', value: 'publicacion' },
            ],
            Tabla: [
                {
                    numero: 1,
                    titulo: 'Caracterización y selección de rizobacterias promotoras de crecimiento en plántulas de Chile poblano (Capsicum annuum L.). Apolinar González Mancilla, Juan José Almaraz Suárez, Ronald Ferrera Cerrato, María Del Pilar Rodríguez Guzmán, Oswaldo Rey Taboada Gaytán, Antonio Trinidad Santos, Alejandro Alarcón, Ramón Ignacio Arteaga Garibay. Revista Internacional de Contaminación Ambiental 33(3): 463-474.',
                    publicacion: 2017,
                },
                {
                    numero: 2,
                    titulo: 'Producción del café a pequeña escala (Coffea arabica L.) en Chiconquiaco, Veracruz, México. Vázquez-López, P.; Hernández-Romero, O.; Vivar-Miranda, R.; González-Mancilla, A. Agroproductividad 10(3): 37-42.',
                    publicacion: 2017,
                },
                {
                    numero: 3,
                    titulo: 'Rizobacterias y hongos micorrízicos arbusculares asociados con chile poblano en la Sierra Nevada de Puebla, México. Apolinar González Mancilla, Juan José Almaraz Suarez, Ronald Ferrera Cerrato, María del Pilar Rodríguez Guzmán, Oswaldo Rey Taboada Gaytán, Antonio Trinidad Santos. Revista Mexicana de Ciencias Agrícolas. Vol. Esp. Núm. 20. 4355-4365.',
                    publicacion: 2018,
                },
                {
                    numero: 4,
                    titulo: 'Characterization of the antifungal activity of three rhizobacterial strains against Rhizoctonia solani Deisy Y. Pineda-Mendoza, Apolinar González-Mancilla, Juan J. Almaraz, María P. Rodríguez-Guzmán, Oscar García-Barradas, Rosalba Argumedo-Delira. Spanish Journal of Agricultural Research 6(4), e1011: 1-10.',
                    publicacion: 2018,
                },
            ],
            headersProy: [
                {
                    text: 'NOMBRE DEL PROYECTO',
                    align: 'start',
                    sortable: false,
                    value: 'nombre',
                },
                { text: 'TIPO DE FINANCIAMIENTO', value: 'tipo' },
            ],
            tablaProyectos: [
                {
                    nombre: 'Selección de Hongos micorrízicos arbusculares asociados al chile jalapeño, cultivados en la Comarca Lagunera.',
                    tipo: 'INTERNO'
                },
                {
                    nombre: 'Crecimiento y rendimiento del chile jalapeño cultivado con diferentes bio-fertilizantes, en la Comarca Lagunera.',
                    tipo: 'INTERNO'
                },
            ]
        }
    },
    methods: {
        insertarRuta(ruta) {
            this.$router.push(ruta);
        },
    },
}
</script>
